module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mbnskms10-4e14f803192fcd66c1727d3026ae7ffb.jpg";